"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipInfoChipTypeEnum = void 0;
exports.ChipInfoChipTypeEnum = {
    FreshCompetition: 'FRESH_COMPETITION',
    YourNumberOneChoice: 'YOUR_NUMBER_ONE_CHOICE',
    LiveCompetition: 'LIVE_COMPETITION',
    CompetitionEndingIn: 'COMPETITION_ENDING_IN',
    VotingEndingSoon: 'VOTING_ENDING_SOON',
    TopRanked: 'TOP_RANKED',
    HighestLiked: 'HIGHEST_LIKED',
    TopRank: 'TOP_RANK',
    FirstPrize: 'FIRST_PRIZE',
    ChoiceAward: 'CHOICE_AWARD'
};
